import React from 'react'

function AddAbout() {
  return (
    <div>
      
    </div>
  )
}

export default AddAbout
